/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Chip, ChipGroup, Search } from '@coursera/cds-core';

import { COURSERA_TEAMS_POPULAR_DOMAINS_MAPPING } from 'bundles/ent-website/constants/misc';

import _t from 'i18n!nls/ent-website';

const styles = {
  container: css`
    margin-bottom: var(--cds-spacing-200);
  `,
};

export interface CourseSearchWidgetV2Props {
  onSearch(query: string): void;
  currentQuery: string;
  onChipClick?(domainId: string): void;
  onFocus?(): void;
  onBlur?(): void;
  onChange?(query: string): void;
}
function CourseSearchV2(props: CourseSearchWidgetV2Props) {
  const [inputQuery, setInputQuery] = React.useState(props.currentQuery);

  const { onChange: onChangeCB } = props;
  const onChange = React.useCallback<(v: string) => void>(
    (value: string) => {
      onChangeCB?.(value);
      setInputQuery(value);
    },
    [onChangeCB]
  );

  const onChipClick = React.useCallback<(idx: number) => () => void>(
    (idx: number) => {
      return () => {
        const query = COURSERA_TEAMS_POPULAR_DOMAINS_MAPPING[idx]?.name ?? '';
        if (COURSERA_TEAMS_POPULAR_DOMAINS_MAPPING[idx]?.id) {
          props.onChipClick?.(COURSERA_TEAMS_POPULAR_DOMAINS_MAPPING[idx].id);
        }
        setInputQuery(query);
        props.onSearch(query);
      };
    },
    [props]
  );

  return (
    <div>
      <Search
        value={inputQuery}
        onChange={onChange}
        fullWidth
        css={styles.container}
        placeholder="Search course, skill or partner.."
        onSearch={props.onSearch}
        data-testid="course-search-v2"
        onFocus={props.onFocus}
        onBlur={props.onBlur}
      />
      <ChipGroup aria-label={_t('Popular skills')}>
        {COURSERA_TEAMS_POPULAR_DOMAINS_MAPPING.map((domain, idx) => (
          <Chip
            key={domain.id}
            onClick={onChipClick(idx)}
            selected={domain.name.toLowerCase() === props.currentQuery.toLowerCase()}
          >
            {domain.name}
          </Chip>
        ))}
      </ChipGroup>
    </div>
  );
}

export default React.memo(CourseSearchV2);
